class SearchPlus {

    constructor(options, callbacks) {
        if(!options.org_id) throw new Error('SearchPlus org_id is required');
        this.org_id = options.org_id;
        this.base_url = options.is_dev ? `http://127.0.0.1:5001/search-plus-3bf60/australia-southeast1` : `https://australia-southeast1-search-plus-3bf60.cloudfunctions.net`;
        this.bust_callbacks = options.bust_callbacks || false;
        this.last_search_id = false;
        this.context = {};
        this.local_storage_key = `searchplus_context`
        this.callbacks = callbacks || [];
        this.init();
    }

    async init(){
        // await this.fetchCallbacks();
        this.context = this.getContext();
        if(Object.keys(this.context).length == 0) return;
        for(const callback of this.callbacks){
            try {
                callback(this.context);
            } catch (err) {
                console.error(`[SP][Callback][Err]`, err);
            }
        }
    }

    async fetchCallbacks(){

        const cached_callbacks = JSON.parse(localStorage.getItem('searchplus_callbacks') || '{}');

        if(!this.bust_callbacks && cached_callbacks && cached_callbacks.exp > Date.now()){
            console.log('[SP] Using cached callbacks...');
            const fns = cached_callbacks.callbacks.map(s => eval(s));
            this.callbacks = this.callbacks.concat(fns);
            console.log(`[SP] Cached callbacks`, this.callbacks);
            return;
        }

        console.log('[SP] Getting fresh callbacks...');
        const response = await fetch(`${this.base_url}/callbacks?org_id=${this.org_id}`, {mode: 'cors'});
        const json = await response.json();
        const callbacks = json.callbacks;
        const server_callbacks = [];
        for(const cb of callbacks){
            let t = eval(`(context) => {${cb.callback}}`);
            server_callbacks.push(t); 
        }
        console.log('[SP] server', server_callbacks);
        this.callbacks = this.callbacks.concat(server_callbacks);
        this.saveCallbacks(server_callbacks);
    }

    async search(query) {
        const t1 = Date.now();
        const response = await fetch(`${this.base_url}/queryV2?org_id=${this.org_id}&q=${query}`, {mode: 'cors'});
        const data = await response.json();
        const t2 = Date.now();
        console.log('Response Time:', t2 - t1);
        this.last_search_id = data.search_id;
        this.saveContext(data);
        return data;
    }

    async clickThrough(url) {
        const response = await fetch(`${this.base_url}/click?org_id=${this.org_id}&search_id=${this.last_search_id}&url=${url}`);
        await this.tagOrderSession('search_plus_id', this.last_search_id);
        const data = await response.json();
        window.location.href = `${url}`;
        return data;
    }

    tagOrderSession(key,value){
    return fetch('/cart', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                attributes: {
                    [key]: value
                }
            })
        });
    }

   getContext(){
     return JSON.parse(localStorage.getItem('searchplus_context') || '{}');
   }

   saveCallbacks(callbacks){
    const data = {
        callbacks: callbacks.map(f => f.toString()),
        exp: Date.now() + 10 * 60 * 1000
    }
    localStorage.setItem('searchplus_callbacks', JSON.stringify(data));
   }

    saveContext(context){
        this.context = {
            ...context,
            updated_at: Date.now()
        };
        localStorage.setItem('searchplus_context', JSON.stringify(context));
    }
}

const injectBenefitsTile = (context) => {

  if(!window.location.href.includes('/products/')) return;
  if(!window.location.href.includes(context.data.product_url)) return;

  const original = document.querySelectorAll('.new_product_short_desc')[0]
  if(original) original.style.display = 'none';
  
  const benefits_html = context.data.tailored_benefits.reduce((str, benefit) => {
    return str+= `<li>${benefit}</li>`
  }, "")
  
    const template = `<div class="new_product_short_desc">
     <p style="font-weight:bold;font-size:20px;">${context.data.tailored_headline}</p>
     <ul>
        ${benefits_html}
     </ul>
     <p></p>
  </div>`

 const atc_btn = document.querySelector('.product-form__buttons');
 atc_btn.insertAdjacentHTML('afterend', template);

  
}


// uUSJpL4O
window.sp = new SearchPlus({ org_id: `uUSJpL4O`}, [injectBenefitsTile]);